import React from 'react'
import { Loader } from '@web/walter-ui-kit'

import localStyles from './style.module.css'
import { useAssetLimits, useCurrencies, useSwapCurrencies, useSwapFeatures } from '~api'

interface Props {
    isError?: boolean
}

function Block({ isError }: Props) {
    return (
        <div className={localStyles.blockContainer} data-pointer="swap_buy_widget_preloader">
            <div className={localStyles.row}>
                <div className={localStyles.label}>
                    <Loader stopAnimation={isError} />
                </div>
                <div className={localStyles.limit}>
                    <Loader stopAnimation={isError} />
                </div>
            </div>
            <div className={localStyles.row}>
                <div className={localStyles.name}>
                    <Loader stopAnimation={isError} />
                </div>
                <div className={localStyles.input}>
                    <Loader borderRadius="xl" stopAnimation={isError} />
                </div>
            </div>
        </div>
    )
}

function Preloader({ isError }: Props) {
    useSwapCurrencies()
    useCurrencies()
    useSwapFeatures()
    useAssetLimits()

    return (
        <div className={localStyles.wrap}>
            <div className={localStyles.container}>
                <Block isError={isError} />
                <div className={localStyles.switcher} />
                <Block isError={isError} />
            </div>

            <div className={localStyles.infoBar}>
                <Loader />
            </div>
        </div>
    )
}

export default Preloader
